import { Reducer } from 'react';

import { IFiltersState } from '../../components/VacanciesBlock/VacanciesBlock';
import {
  Action,
  IGroup,
  IMainPage,
  IMainPayload,
  IOfficePage,
  IOperationsPage,
  ITechPage,
  IVacancy,
} from '../../utils/types/state-types';
import {
  MAIN_PAGE_RECEIVED,
  MAIN_PAGE_REJECTED,
  MAIN_PAGE_REQUESTED,
  OFFICE_PAGE_RECEIVED,
  OFFICE_PAGE_REJECTED,
  OFFICE_PAGE_REQUESTED,
  OPEN_MOBILE_SEARCH_RECEIVED,
  OPERATIONS_PAGE_RECEIVED,
  OPERATIONS_PAGE_REJECTED,
  OPERATIONS_PAGE_REQUESTED,
  SEARCH_VACANCIES_RECEIVED,
  SEARCH_VACANCIES_REJECTED,
  SEARCH_VACANCIES_REQUESTED,
  SEARCH_VACANCY_GROUP_RECEIVED,
  SEARCH_VACANCY_GROUP_REJECTED,
  SEARCH_VACANCY_GROUP_REQUESTED,
  SEARCH_VACANCY_RECEIVED,
  SET_SEARCH_VALUE_REQUESTED,
  TECH_PAGE_RECEIVED,
  TECH_PAGE_REJECTED,
  TECH_PAGE_REQUESTED,
} from '../actions/main-page';

export interface IMainReducerState {
  divisions: string[] | [];
  error?: string;
  vacancies: IVacancy[] | [];
  isLoading: boolean;
  isSearchOpen?: boolean;
  groups: IGroup[] | [];
  searchValue: string;
  filterValues: IFiltersState;
  mainPage: IMainPage | null;
  officePage: IOfficePage | null;
  techPage: ITechPage | null;
  operationsPage: IOperationsPage | null;
}

const initialState = {
  vacancies: [],
  error: '',
  divisions: [],
  isLoading: true,
  isSearchOpen: false,
  groups: [],
  searchValue: '',
  filterValues: {
    employmentType: [],
    grade: [],
    workFormat: [],
    city: [],
  },
  mainPage: null,
  officePage: null,
  techPage: null,
  operationsPage: null,
} as IMainReducerState;

const mainReducer: Reducer<IMainReducerState, Action> = (state = initialState, action: Action) => {
  const { type } = action;
  switch (type) {
    case SEARCH_VACANCIES_REQUESTED: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }
    case SEARCH_VACANCIES_REJECTED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    case SEARCH_VACANCIES_RECEIVED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        vacancies: payload.vacancies,
        divisions: payload.divisions,
        error: '',
      };
    }
    case OPEN_MOBILE_SEARCH_RECEIVED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isSearchOpen: payload.isSearchOpen,
      };
    }
    case SEARCH_VACANCY_GROUP_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SEARCH_VACANCY_GROUP_REJECTED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    case SEARCH_VACANCY_GROUP_RECEIVED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        groups: payload.groups,
        vacancies: payload.vacancies,
        error: '',
        filterValues: payload.filterValues,
      };
    }
    case SEARCH_VACANCY_RECEIVED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        vacancies: payload.vacancies,
        error: '',
      };
    }
    case SET_SEARCH_VALUE_REQUESTED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        searchValue: payload.searchValue,
      };
    }
    case MAIN_PAGE_REQUESTED: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }
    case MAIN_PAGE_RECEIVED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        mainPage: payload.mainPage,
        error: '',
      };
    }
    case MAIN_PAGE_REJECTED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    case OFFICE_PAGE_REQUESTED: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }
    case OFFICE_PAGE_RECEIVED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        officePage: payload.officePage,
        error: '',
      };
    }
    case OFFICE_PAGE_REJECTED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    case OPERATIONS_PAGE_REQUESTED: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }
    case OPERATIONS_PAGE_RECEIVED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        operationsPage: payload.operationsPage,
        error: '',
      };
    }
    case OPERATIONS_PAGE_REJECTED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    case TECH_PAGE_REQUESTED: {
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    }
    case TECH_PAGE_RECEIVED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        techPage: payload.techPage,
        error: '',
      };
    }
    case TECH_PAGE_REJECTED: {
      const { payload } = action as Action<IMainPayload>;
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    }
    default:
      return state;
  }
};

export default mainReducer;
